import { render, staticRenderFns } from "./FiMultiselect.vue?vue&type=template&id=77a10633&lang=pug&"
import script from "./FiMultiselect.vue?vue&type=script&lang=js&"
export * from "./FiMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./FiMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FiMultiselect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports